import { render, staticRenderFns } from "./DetailTabs.vue?vue&type=template&id=2761ecbd&scoped=true&"
import script from "./DetailTabs.vue?vue&type=script&lang=js&"
export * from "./DetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./DetailTabs.vue?vue&type=style&index=0&id=2761ecbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761ecbd",
  null
  
)

component.options.__file = "DetailTabs.vue"
export default component.exports